module.exports = __webpack_public_path__ + "static/metaSummitBG-f6a3e4634b3ab45b79026a11ab971920.jpg";